const links = [
    {
        title: 'Dashboard',
        icon: 'dashboard',
        path: '/'
    },
    {
        title: 'Sureclaims Patients',
        icon: '',
        path: '/sureclaims/cf4/list'
    },
    // {
    //     title: 'CF4',
    //     icon: '',
    //     path: '/generate'
    // },
    {
        title: 'CF4 Records',
        icon: '',
        path: '/list'
    }
];

export default links;